import {TaskStatus} from 'onboarding/OnboardingConstants';

export enum NUEModule {
  SEQUENCE = 'sequence',
  ENTRY = 'entry',
  GETTING_STARTED = 'getting_started',
}

export type NUEModules = {
  [key in NUEModule]?: NUEModuleState;
};

export interface NUEModuleState {
  acknowledgedCompleted: boolean;
  collapsed: boolean;
  completed?: boolean;
  dismissed: boolean;
  openIndex: number | null;
  tasks: Array<TaskStatus> | null;
}

const ONE_GIGABYTE = 1024 * 1024 * 1024;

export default {
  // Keep this in sync with models/onboarding_task and models/space_addition.
  VERIFY_EMAIL: 'verify_email',
  SET_RECOVERY_EMAIL: 'set_recovery_email',
  MAIN_TOUR: 'main_tour',
  CREATE_FIRST_FILE: 'create_first_file',
  CHAT_BENCHLING: 'chat_benchling',
  VERIFY_ACADEMIC: 'verify_academic',
  INVITE_MEMBER: 'invite_member',
  CREATE_OR_JOIN_ORG: 'create_or_join_org',

  MODULES: {
    SEQUENCE: NUEModule.SEQUENCE,
    ENTRY: NUEModule.ENTRY,
    GETTING_STARTED: NUEModule.GETTING_STARTED,
  },

  READABLE_MODULES: {
    [NUEModule.SEQUENCE]: 'sequence',
    [NUEModule.ENTRY]: 'entry',
    [NUEModule.GETTING_STARTED]: 'getting started',
  } as {[key in NUEModule]: string},

  OPEN_FILE: 'open_file',

  AUTO_ANNOTATE: 'auto_annotate',
  SPLIT_WORKSPACE: 'split_workspace',
  IMPORT_SEQUENCE: 'import_sequence',
  VIEW_ALIGNMENT: 'view_alignment',
  RUN_DIGEST: 'run_digest',

  CREATE_ENTRY: 'create_entry',
  INSERT_DAY: 'insert_day',
  CREATE_EDIT_TABLE: 'create_edit_table',
  LINK_SEQUENCE: 'link_sequence',
  ATTACH_PROTOCOL: 'attach_protocol',

  SPACE_ADDITION_SIZES: {
    INVITE_MEMBER: ONE_GIGABYTE,
    VERIFY_ACADEMIC: ONE_GIGABYTE,
    ONBOARDING: {
      [NUEModule.GETTING_STARTED]: ONE_GIGABYTE,
      [NUEModule.SEQUENCE]: ONE_GIGABYTE,
      [NUEModule.ENTRY]: ONE_GIGABYTE,
    } as {[key in NUEModule]: number},
  },

  // TODO(T3753) use new NUE module for sequences
  LEGACY_CHECKLIST_MODULES: [NUEModule.SEQUENCE],

  MAX_INVITES: 20,
};

export const OnboardingPreferences = {
  MINIMIZE_FILE_ONBOARDING: 'minimize_file_onboarding_status',
  PULSER_NAMESPACE: 'pulser.',
  DISABLED_PULSE: 'pulser.disabled',
};
